package api.repository.adminProfile

import api.data.response.DataAdminProfile
import api.service.adminProfile.ServiceAdminProfile

class ImplRepositoryAdminProfile(val serviceAdminProfile: ServiceAdminProfile) : RepositoryAdminProfile{
    override suspend fun getAdminProfile(): DataAdminProfile? {
        return serviceAdminProfile.getAdminProfile()
    }

    override suspend fun updateAdminProfile(adminProfile: DataAdminProfile): Boolean {
        return serviceAdminProfile.updateAdminProfile(adminProfile)
    }
}